module.exports = __webpack_public_path__ + "img/become_member-1.14c3b864.png";